export { default, type AboutSectionProps, SECTION_ID as aboutSectionId } from './AboutSection';
